import actions from "@/store/box/actions";
import mutations from "@/store/box/mutations";
import state from "@/store/box/state";
export default {
    actions,
    mutations,
    state
}